import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfeedbackrunner1getGetFeedbackResponseSchema = jsonObject
export type tcpfeedbackrunner1getGetFeedbackResponse = z.infer<typeof tcpfeedbackrunner1getGetFeedbackResponseSchema>
